<template>
  <div class="panel-container">
    <IntegrationConfigCard
      v-bind="$props"
    />
    <TallyFormCard
      form-url="https://hello.datapeople.io/gr8people"
    />
  </div>
</template>

<script>
import IntegrationConfigCard from '@/components/settings/integrations/IntegrationConfigCard.vue';
import TallyFormCard from '@/components/settings/integrations/TallyFormCard.vue';

export default {
  name: 'Gr8peopleSettings',
  components: {
    IntegrationConfigCard,
    TallyFormCard,
  },
  props: {
    atsName: { type: String, default: '' },
    guidance: { type: String, default: '' },
    logoUrl: { type: String, default: '' },
  },
};
</script>
